var r = /* @__PURE__ */ ((O) => (O.CONTACT_PERSON = "contact-person", O.FOOTER = "footer", O.FOOTER_QUICK = "footer-quick", O.FOOTER_COLUMN = "footer-column", O.FOOTER_SOCIAL = "footer-social", O.FOOTER_SERVICE = "footer-service", O.BREADCRUMBS = "breadcrumbs", O.NEWS_PAGE = "news-page", O.RESPONSIVE_TABLE = "responsive-table", O))(r || {}), E = /* @__PURE__ */ ((O) => (O.FOOTNOTE = "footnote", O))(E || {});
export {
  E as RocheUITextLinkIconSize,
  r as RocheUITextLinkType
};
